import { axiosInstance } from "@src/api/axiosConfig";
import { useQuery } from "react-query";

const nestPath = process.env.REACT_APP_NEST_API_URL;

// 내 건축사 광고 목록 조회
export interface getMyArchitectADListRequest {
    adStatus?: "normal" | "closed";
}

export interface getMyArchitectADListResponse {
    list: {
        ceo: string | null;
        name: string;
        address: string;
        phone: string;
        url: string;
        createdAt: string;
        expiredAt: string;
        status: number;
    }[];
    countInfo: {
        totalCount: number;
        normalCount: number;
        closedCount: number;
    };
}

export const getMyArchitectADList = async (params: getMyArchitectADListRequest): Promise<getMyArchitectADListResponse> => {
    const { data } = await axiosInstance.get(`${nestPath}/expert-banner/architects/my`, { params });
    return data;
};

export const useGetMyArchitectADList = (params: getMyArchitectADListRequest) => {
    return useQuery<getMyArchitectADListResponse>({
        queryKey: ["myArchitectADList", params],
        queryFn: () => getMyArchitectADList(params),
    });
};
